import { TRANSACTIONS_API_ENDPOINT } from "../../../constants/constant";
import baseApi from "../../baseApi";
import { ApiResponse, ResultType, TransactionsType } from "./transactions.type";

export interface UserQueryParams {
  search?: string;
  status?: string;
  userType?: string;
  transactionType?: string;
  limit?: number;
  page?: number;
  campaignType?: any;
}

export const transactionsApiSlice = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTransactionsApiCall: build.query<
      ApiResponse<ResultType<TransactionsType>>,
      UserQueryParams | void
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();

        if (params?.search) queryParams.append("search", params.search);
        if (params?.page) queryParams.append("page", params.page.toString());
        if (params?.limit) queryParams.append("limit", params.limit.toString());
        if (params?.status) queryParams.append("status1", params.status);
        if (params?.campaignType)
          queryParams.append("campaignType", params.campaignType);

        if (params?.transactionType)
          queryParams.append("transactionType", params.transactionType);

        return `${
          TRANSACTIONS_API_ENDPOINT.GET_TRANSACTIONS
        }?${queryParams.toString()}`;
      },
      // providesTags: ["Users"],
    }),

    getTransactionsHistoryApiCall: build.query<
      ApiResponse,
      UserQueryParams | void
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();

        if (params?.transactionType)
          queryParams.append("transactionType", params.transactionType);
        if (params?.search) queryParams.append("search", params.search);
        if (params?.status) queryParams.append("status1", params.status);

        return `${
          TRANSACTIONS_API_ENDPOINT.GET_TRANSACTIONS_HISTORY
        }?${queryParams.toString()}`;
      },
      // providesTags: ["Users"],
    }),
  }),
});

export const {
  useGetTransactionsApiCallQuery,
  useLazyGetTransactionsApiCallQuery,
  useGetTransactionsHistoryApiCallQuery,
} = transactionsApiSlice;

export default transactionsApiSlice;
